import { render, staticRenderFns } from "./OrderStatusCanceledIcon.vue?vue&type=template&id=45009201&scoped=true&"
import script from "./OrderStatusCanceledIcon.vue?vue&type=script&lang=js&"
export * from "./OrderStatusCanceledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45009201",
  null
  
)

export default component.exports